import { vcarsEndpoint } from '../data/vcarsEndpoint';

export type FormType = 'consulta' | 'permuta' | 'simulacion';

export const isVcarsEndpointConfigured = vcarsEndpoint.scriptUrl !== '';

/** Envía un formulario al script de Google, que lo guarda en la pestaña correspondiente. */
export async function sendToVcars(tipoFormulario: FormType, data: Record<string, string>): Promise<void> {
  if (!isVcarsEndpointConfigured) {
    // Sin URL configurada los datos no se guardan (solo vista previa).
    await new Promise((resolve) => window.setTimeout(resolve, 700));
    return;
  }

  // text/plain evita la verificación previa de CORS; el script lo lee con JSON.parse.
  await fetch(vcarsEndpoint.scriptUrl, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({ tipoFormulario, ...data }),
  });
}
